
const API = {
    UPLOAD_IMAGE:'/admin/upload',
    GET_LIST_SEO:'/admin/checkSEOKeyword',
    //field project
    GET_LIST_FIELD_PROJECT:'/admin/field-project',
    GET_DETAIL_FIELD_PROJECT:'/admin/field-project',
    SAVE_FIELD_PROJECT:'/admin/field-project',
    DELETE_FIELD_PROJECT:'/admin/field-project',
    UPDATE_FIELD_PROJECT:'/admin/field-project',
    //TAGS
    GET_LIST_TAGS:'/admin/tag',
    SAVE_TAG: '/admin/tag',
    GET_DETAIL_TAGS: '/admin/tag',
    UPDATE_TAG: '/admin/tag',
    DELETE_TAG: '/admin/tag',
    //project
    GET_LIST_PROJECT: '/admin/project',
    GET_DETAIL_PROJECT: '/admin/project',
    UPDATE_PROJECT: '/admin/project',
    SAVE_PROJECT: '/admin/project',
    DELETE_PROJECT: '/admin/project',
    SEARCH_PROJECT:'/admin/search-project',
    UPDATE_ACTIVE:'/admin/update-active',
    //news
    GET_LIST_NEWS :'/admin/news',
    GET_DETAIL_NEWS :'/admin/news',
    SAVE_NEWS :'/admin/news',
    DELETE_NEWS :'/admin/news',
    UPDATE_NEWS :'/admin/news',
    //career
    GET_LIST_CAREER :'/admin/carrer',
    GET_DETAIL_CAREER: '/admin/carrer',
    SAVE_CAREER: '/admin/carrer',
    DELETE_CAREER: '/admin/carrer',
    UPDATE_CAREER: '/admin/carrer',
    SEARCH_CAREER:'/admin/search-carrer',
    //position
    GET_LIST_POSITION: '/admin/position-carrer',
    GET_DETAIL_POSITION: '/admin/position-carrer',
    SAVE_POSITION: '/admin/position-carrer',
    DELETE_POSITION: '/admin/position-carrer',
    UPDATE_POSITION: '/admin/position-carrer',
    //cv
    GET_LIST_CV: '/admin/form-cv-admin',
    GET_DETAIL_CV: '/admin/form-cv-admin',
    DELETE_CV: '/admin/form-cv-admin',
    SET_LIST_CV: '/admin/form-cv-admin',
    SET_DETAIL_CV: '/admin/form-cv-admin',
    //contact
    GET_LIST_CONTACT:'/admin/contact',
    GET_DETAIL_CONTACT:'/admin/contact',
    UPDATE_CONTACT:'/admin/contact',
    SAVE_CONTACT:'/admin/contact',
    DELETE_CONTACT:'/admin/contact',

    //technology
    GET_LIST_TECHNOLOGY:'/admin/technology',
    GET_DETAIL_TECHNOLOGY:'/admin/technology',
    UPDATE_TECHNOLOGY:'/admin/technology',
    SAVE_TECHNOLOGY:'/admin/technology',
    DELETE_TECHNOLOGY:'/admin/technology',

    //service
    GET_LIST_SERVICE:'/admin/service',
    GET_DETAIL_SERVICE:'/admin/service',
    UPDATE_SERVICE:'/admin/service',
    SAVE_SERVICE:'/admin/service',
    DELETE_SERVICE:'/admin/service',

    //process
    GET_LIST_PROCESS:'/admin/process',
    GET_DETAIL_PROCESS:'/admin/process',
    UPDATE_PROCESS:'/admin/process',
    SAVE_PROCESS:'/admin/process',
    DELETE_PROCESS:'/admin/process',

    //Consultation
    GET_LIST_CONSULTATION: '/admin/consultation-form-admin',
    GET_DETAIL_CONSULTATION: '/admin/consultation-form-admin',

    //banner
    GET_LIST_BANNER: '/admin/configPage/home/banner',
    GET_DETAIL_BANNER: '/admin/configPage/home/banner',
    UPDATE_BANNER: '/admin/configPage/home/banner',
    SAVE_BANNER: '/admin/configPage/home/banner',
    DELETE_BANNER: '/admin/configPage/home/banner',

    //partner

    GET_LIST_PARTNER: '/admin/partners',
    GET_DETAIL_PARTNER: '/admin/partners',
    UPDATE_PARTNER: '/admin/partners',
    SAVE_PARTNER: '/admin/partners',
    DELETE_PARTNER: '/admin/partners',

}
export default  API